export const getContacts = state => state.contacts;
export const getPeople = state => getContacts(state).people;
export const getCompanies = state => getContacts(state).companies;
export const isLoading = state => getContacts(state).isLoading;
export const getLoadError = state => getContacts(state).error;

export const getPersonColumns = state => state.session.currentPersonColumns;
export const getCompanyColumns = state => state.session.currentCompanyColumns;
